var map = {
	"./de.json": [
		1706,
		41
	],
	"./en-AU.json": [
		1707,
		42
	],
	"./en-GB.json": [
		1708,
		43
	],
	"./en-HK.json": [
		1709,
		44
	],
	"./en-SG.json": [
		1710,
		45
	],
	"./en-us.json": [
		1711,
		46
	],
	"./fr.json": [
		1712,
		47
	],
	"./global.json": [
		1713,
		48
	],
	"./it.json": [
		1714,
		49
	],
	"./zh-Hant.json": [
		1715,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1703;
module.exports = webpackAsyncContext;